<template>
  <div class="home-retain-tab content-main">
    <div class="content-main__centered">
      <h4 class="appMain--text mb-2">Retain</h4>
      <p class="mb-4">
        Keep your team engaged and motivated for the long term.
      </p>

      <v-card class="pa-6 text-center">
        <v-icon size="48" color="grey lighten-1" class="mb-4">
          mdi-heart-outline
        </v-icon>
        <h5 class="text-h6 mb-2">Retention Tools</h5>
        <p class="text-body-2 grey--text">
          Build loyalty and reduce turnover in your organization.
        </p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRetainTab',
};
</script>
